import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'

// accounts
const AccountSearch = () => import(/* webpackChunkName: "accounts" */ 'src/pages/Account/SimpleAccountSearch.vue');
const AccountProfile = () => import(/* webpackChunkName: "accounts" */ 'src/pages/Account/AccountProfile.vue');

// reporting
const OperatorTicketsReport = () => import(/* webpackChunkName: "operator_reporting" */ 'src/pages/Report/OperatorTicketsReport.vue');
const OperatorJourneysCountReport = () => import(/* webpackChunkName: "operator_reporting" */ 'src/pages/Report/OperatorJourneysCountReport.vue');
const OperatorJourneyStatsReport = () => import(/* webpackChunkName: "operator_reporting" */ 'src/pages/Report/OperatorJourneyStatsReport');
const OperatorRoutesStatsReport = () => import(/* webpackChunkName: "operator_reporting" */ 'src/pages/Report/OperatorRoutesStatsReport');
const CreditDebitReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/CreditDebitReport.vue');
const ReportingProfiles = () => import(/* webpackChunkName: "reporting" */ 'src/pages/ReportingProfiles/ReportingProfiles.vue');
const ReportingProfileView = () => import(/* webpackChunkName: "reporting" */ 'src/pages/ReportingProfiles/ReportingProfileView.vue');
const ReportingProfileTicketsReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/ReportingProfiles/ReportingProfileTicketsReport.vue');
const DistributorsSummaryReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/DistributorsSummaryReport');
const DistributorReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/DistributorReport');
const SoldSeasonTicketsReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/SoldSeasonTicketsReport');
const CanceledSeasonTicketsReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/CanceledSeasonTicketsReport');
const SeasonTicketsCountReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/SeasonTicketsCountReport');
const InspectionLocksReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/InspectionLocksReport');
const JourneysByStopMunicipalitiesReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/JourneysByStopMunicipalitiesReport');
const EmvTapsSummaryReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/EmvTapsSummaryReport');
const EmvSuccessPaymentsReport = () => import(/* webpackChunkName: "reporting" */ 'src/pages/Report/EmvSuccessPaymentsReport');

// data_preview
const MoneyClaimsView = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/MoneyClaims/MoneyClaimsView.vue');
const AccountDeletionsView = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/AccountDeletions/AccountDeletionsView');
const TopUps = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/Topups/TopUps');
const PosTransactions = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/PosTransactions/PosTransactions');
const PosTransaction = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/PosTransactions/PosTransaction');
const CardsPage = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/Cards/CardsPage');
const CardPage = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/Card/CardPage');
const PTSchedules = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/PTSchedules/PTSchedules.vue');
const InspectionEvents = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/InspectionEvents/InspectionEvents.vue');
const AuditLogs = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/Audit/AuditLogs.vue');
const AuditLog = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/Audit/AuditLogPage.vue');
const Emails = () => import(/* webpackChunkName: "data_preview" */ "src/pages/Emails/Emails");
const ExternalEmvTaps = () => import(/* webpackChunkName: "data_preview" */ "src/pages/ExternalEmvTaps/ExternalEmvTaps");
const ExternalEmvTap = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/ExternalEmvTaps/ExternalEmvTap');
const EmvClearings = () => import(/* webpackChunkName: "data_preview" */ "src/pages/EmvClearings/EmvClearings");
const EmvClearing = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/EmvClearings/EmvClearing');
const EmvCutOvers = () => import(/* webpackChunkName: "data_preview" */ "src/pages/EmvCutOvers/EmvCutOvers");
const EmvCutOver = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/EmvCutOvers/EmvCutOver');
const EmvTaps = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/EmvTaps/EmvTaps');
const EmvTap = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/EmvTaps/EmvTap');
const OfflineFilters = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/OfflineFilters/OfflineFilters');
const OfflineFilter = () => import(/* webpackChunkName: "data_preview" */ 'src/pages/OfflineFilters/OfflineFilter');

// sys_config
const FareGroups = () => import(/* webpackChunkName: "sys_config" */ "src/pages/FareGroup/FareGroups");
const FareGroupView = () => import(/* webpackChunkName: "sys_config" */ "src/pages/FareGroup/FareGroupView");
const Operators = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Operators/Operators.vue');
const OperatorView = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Operators/OperatorView.vue');
const Discounts = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Discounts/Discounts.vue');
const PTMappings = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/PTMappings/PTMappings.vue');
const PtZones = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/PTZones/PtZones.vue');
const Municipalities = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Municipalities/Municipalities.vue');
const Municipality = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Municipalities/Municipality.vue');
const BotClients = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/BotClients/BotClients.vue');
const BotClient = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/BotClients/BotClient.vue');
const PtStops = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/PTStops/PtStops.vue');
const NotificationConfigs = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Notifications/NotificationConfigs.vue');
const EmailTemplates = () => import(/* webpackChunkName: "sys_config" */ "src/pages/EmailTemplates/EmailTemplates");
const Distributors = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Distributors/Distributors.vue');
const Distributor = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/Distributors/Distributor.vue');
const SeasonTickets = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/SeasonTickets/SeasonTickets.vue');
const SeasonTicket = () => import(/* webpackChunkName: "sys_config" */ 'src/pages/SeasonTickets/SeasonTicket.vue');

// import DashboardLayout from './../pages/Starter/SampleLayout.vue';
// general
const DashboardLayout = () => import(/* webpackChunkName: "general" */ 'src/pages/Layout/DashboardLayout.vue');
const AuthLayout = () => import(/* webpackChunkName: "general" */ 'src/pages/Layout/AuthLayout.vue');
const Starter = () => import(/* webpackChunkName: "general" */ 'src/pages/Starter/SamplePage.vue');
const NotFound = () => import(/* webpackChunkName: "general" */ 'src/pages/GeneralViews/NotFoundPage.vue');
const Forbidden = () => import(/* webpackChunkName: "general" */ 'src/pages/GeneralViews/ForbiddenPage.vue');
const Login = () => import(/* webpackChunkName: "general" */ 'src/pages/Pages/Login.vue');
const Logout = () => import(/* webpackChunkName: "general" */ 'src/pages/Pages/Logout.vue');
const PasswordReset = () => import(/* webpackChunkName: "general" */ 'src/pages/Pages/PasswordReset.vue');
const PasswordForgot = () => import(/* webpackChunkName: "general" */ 'src/pages/Pages/PasswordForgot.vue');
const Profile = () => import(/* webpackChunkName: "general" */ 'src/pages/Profile/Profile');

// system
const SystemAccounts = () => import(/* webpackChunkName: "system" */ 'src/pages/SystemAccounts/SystemAccounts.vue');
const SystemAccount = () => import(/* webpackChunkName: "system" */ 'src/pages/SystemAccounts/SystemAccount.vue');
const Roles = () => import(/* webpackChunkName: "system" */ 'src/pages/Roles/Roles.vue');
const InspectorTeams = () => import(/* webpackChunkName: "system" */ 'src/pages/InspectorTeams/InspectorTeams.vue');
const InspectorTeam = () => import(/* webpackChunkName: "system" */ 'src/pages/InspectorTeams/InspectorTeam.vue');
const PtLocks = () => import(/* webpackChunkName: "system" */ 'src/pages/PtLocks/PtLocks');

Vue.use(VueRouter);
Vue.use(RouterPrefetch);


let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {title: 'passwordReset', auth: false}
    },
    {
      path: '/forgot-password',
      name: 'PasswordForgot',
      component: PasswordForgot,
      meta: {title: 'passwordForgot', auth: false}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {title: 'login', auth: false}
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: {title: 'logout', auth: true}
    }
  ]
};

let dataPages = {
  path: '/data',
  component: DashboardLayout,
  name: 'Data',
  children: [
    {
      path: 'money-claims',
      name: 'money-claims',
      components: {default: MoneyClaimsView},
      meta: {title: 'moneyClaims', auth: true},
    },
    {
      path: 'account-deletions',
      name: 'account-deletions',
      components: {default: AccountDeletionsView},
      meta: {title: 'accountDeletions', auth: true},
    },
    {
      path: 'pt-schedules',
      name: 'pt-schedules',
      components: {default: PTSchedules},
      meta: {title: 'ptSchedules', auth: true},
    },
    {
      path: 'top-ups',
      name: 'top-ups',
      components: {default: TopUps},
      meta: {title: 'topUp', auth: true},
    },
    {
      path: 'pos-transactions',
      name: 'pos-transactions',
      components: {default: PosTransactions},
      meta: {title: 'posTransactions', auth: true},
    },
    {
      path: 'pos-transactions/:id',
      name: 'pos-transaction',
      components: {default: PosTransaction},
      meta: {title: 'posTransaction', auth: true},
    },
    {
      path: 'cards',
      name: 'cards',
      components: {default: CardsPage},
      meta: {title: 'cards', auth: true},
    },
    {
      path: 'cards/:id',
      name: 'card-page',
      components: {default: CardPage},
      meta: {title: 'cardPage', auth: true},
    },
    {
      path: 'emv-taps',
      name: 'emvTaps',
      components: {default: EmvTaps},
      meta: {title: 'emvTaps', auth: true},
    },
    {
      path: 'emv-taps/:id',
      name: 'emvTap',
      components: {default: EmvTap},
      meta: {title: 'emvTap', auth: true},
    },
    {
      path: 'external-emv-taps',
      name: 'externalEmvTaps',
      components: {default: ExternalEmvTaps},
      meta: {title: 'externalEmvTaps', auth: true},
    },
    {
      path: 'external-emv-taps/:id',
      name: 'externalEmvTap',
      components: {default: ExternalEmvTap},
      meta: {title: 'externalEmvTap', auth: true},
    },
    {
      path: 'emv-clearings',
      name: 'emvClearings',
      components: {default: EmvClearings},
      meta: {title: 'emvClearings', auth: true},
    },
    {
      path: 'emv-clearings/:id',
      name: 'emvClearing',
      components: {default: EmvClearing},
      meta: {title: 'emvClearing', auth: true},
    },
    {
      path: 'emv-cut-overs',
      name: 'emvCutOvers',
      components: {default: EmvCutOvers},
      meta: {title: 'emvCutOvers', auth: true},
    },
    {
      path: 'emv-cut-overs/:id',
      name: 'emvCutOver',
      components: {default: EmvCutOver},
      meta: {title: 'emvCutOver', auth: true},
    },
    {
      path: 'audit-logs',
      name: 'audit-logs',
      components: {default: AuditLogs},
      meta: {title: 'auditLogs', auth: true},
    },
    {
      path: 'audit-logs/:id',
      name: 'auditLog',
      components: {default: AuditLog},
      meta: {title: 'auditLog', auth: true},
    },
    {
      path: 'emails',
      name: 'emails',
      components: {default: Emails},
      meta: {title: 'emails', auth: true},
    },
    {
      path: 'offline-filters',
      name: 'offlineFilters',
      components: {default: OfflineFilters},
      meta: {title: 'offlineFilters', auth: true},
    },
    {
      path: 'offline-filters/:id',
      name: 'offlineFilter',
      components: {default: OfflineFilter},
      meta: {title: 'offlineFilter', auth: true},
    },
    {
      path: 'inspection-events',
      name: 'inspection_events',
      components: {default: InspectionEvents},
      meta: {title: 'inspection_events', auth: true},
    },
  ]
};

let configPages = {
  path: '/config',
  component: DashboardLayout,
  name: 'Config',
  children: [
    {
      path: 'fare-groups',
      name: 'fare-groups',
      components: {default: FareGroups},
      meta: {title: 'fareGroups', auth: true},
    },
    {
      path: 'fare-groups/:id',
      name: 'fare-group',
      components: {default: FareGroupView},
      meta: {title: 'fareGroup', auth: true},
    },
    {
      path: 'operators',
      name: 'operators',
      components: {default: Operators},
      meta: {title: 'operators', auth: true},
    },
    {
      path: 'operators/:id',
      name: 'operator',
      components: {default: OperatorView},
      meta: {title: 'operator', auth: true},
    },
    {
      path: 'discounts',
      name: 'discounts',
      components: {default: Discounts},
      meta: {title: 'discounts', auth: true},
    },
    {
      path: 'municipalities',
      name: 'municipalities',
      components: {default: Municipalities},
      meta: {title: 'municipalities', auth: true},
    },
    {
      path: 'municipalities/:id',
      name: 'municipality',
      components: {default: Municipality},
      meta: {title: 'municipality', auth: true},
    },
    {
      path: 'bot-clients',
      name: 'bot-clients',
      components: {default: BotClients},
      meta: {title: 'botClients', auth: true},
    },
    {
      path: 'bot-clients/:id',
      name: 'bot-client',
      components: {default: BotClient},
      meta: {title: 'botClient', auth: true},
    },
    {
      path: 'pt-mappings',
      name: 'pt-mappings',
      components: {default: PTMappings},
      meta: {title: 'ptMappings', auth: true},
    },
    {
      path: 'pt-zones',
      name: 'pt-zones',
      components: {default: PtZones},
      meta: {title: 'ptZones', auth: true},
    },
    {
      path: 'pt-stops',
      name: 'pt-stops',
      components: {default: PtStops},
      meta: {title: 'ptStops', auth: true},
    },
    {
      path: 'notification-configs',
      name: 'notification-configs',
      components: {default: NotificationConfigs},
      meta: {title: 'notificationConfigs', auth: true},
    },
    {
      path: 'email-templates',
      name: 'email-templates',
      components: {default: EmailTemplates},
      meta: {title: 'emailTemplates', auth: true},
    },
    {
      path: 'distributors',
      name: 'distributors',
      components: {default: Distributors},
      meta: {title: 'distributors', auth: true},
    },
    {
      path: 'distributors/:id',
      name: 'distributor',
      components: {default: Distributor},
      meta: {title: 'distributor', auth: true},
    },
    {
      path: 'season-tickets',
      name: 'season_tickets',
      components: {default: SeasonTickets},
      meta: {title: 'seasonTickets', auth: true},
    },
    {
      path: 'season-tickets/:id',
      name: 'season_ticket',
      components: {default: SeasonTicket},
      meta: {title: 'seasonTicket', auth: true},
    },
  ]
};

let accountPages = {
  path: '/account',
  component: DashboardLayout,
  name: 'Account',
  meta: {title: 'account', auth: true},
  children: [
    {
      path: 'search',
      name: 'search',
      components: {default: AccountSearch},
      meta: {title: 'accountSearch', auth: true},
    },
    {
      path: 'profile/:id/associations/:association_id/:type',
      name: 'account-association',
      components: {default: AccountProfile},
      meta: {title: 'accountAssociation', auth: true},
    },
    {
      path: 'profile/:id/associations',
      name: 'account-associations',
      components: {default: AccountProfile},
      meta: {title: 'accountAssociations', auth: true},
    },
    {
      path: 'profile/:id/journeys/:journey_id',
      name: 'account-journey-details',
      components: {default: AccountProfile},
      meta: {title: 'accountJourneyDetails', auth: true},
    },
    {
      path: 'profile/:id/journeys',
      name: 'account-journeys',
      components: {default: AccountProfile},
      meta: {title: 'accountJourneys', auth: true},
    },
    {
      path: 'profile/:id/emv-taps/:resource_id',
      name: 'account-emv-tap-details',
      components: {default: AccountProfile},
      meta: {title: 'accountEmvTapDetails', auth: true},
    },
    {
      path: 'profile/:id/emv-taps',
      name: 'account-emv-taps',
      components: {default: AccountProfile},
      meta: {title: 'accountEmvTaps', auth: true},
    },
    {
      path: 'profile/:id/emv-clearings/:resource_id',
      name: 'account-emv-clearing',
      components: {default: AccountProfile},
      meta: {title: 'accountEmvClearing', auth: true},
    },
    {
      path: 'profile/:id/emv-clearings',
      name: 'account-emv-clearings',
      components: {default: AccountProfile},
      meta: {title: 'accountEmvClearings', auth: true},
    },
    {
      path: 'profile/:id/purchases/:resource_id',
      name: 'account-purchase-details',
      components: {default: AccountProfile},
      meta: {title: 'accountPurchaseDetails', auth: true},
    },
    {
      path: 'profile/:id/purchases',
      name: 'account-purchases',
      components: {default: AccountProfile},
      meta: {title: 'accountPurchases', auth: true},
    },
    {
      path: 'profile/:id/taps/:resource_id',
      name: 'account-tap-details',
      components: {default: AccountProfile},
      meta: {title: 'accountTapDetails', auth: true},
    },
    {
      path: 'profile/:id/taps',
      name: 'account-taps',
      components: {default: AccountProfile},
      meta: {title: 'accountTaps', auth: true},
    },
    {
      path: 'profile/:id/top-ups',
      name: 'account-top-ups',
      components: {default: AccountProfile},
      meta: {title: 'accountTopUps', auth: true},
    },
    {
      path: 'profile/:id/top-ups/:top_up_id',
      name: 'account-top-ups-details',
      components: {default: AccountProfile},
      meta: {title: 'accountTopUpsDetails', auth: true},
    },
    {
      path: 'profile/:id/money-claims',
      name: 'account-money-claims',
      components: {default: AccountProfile},
      meta: {title: 'accountMoneyClaims', auth: true},
    },
    {
      path: 'profile/:id/money-claims/:money_claim_id',
      name: 'account-money-claims-details',
      components: {default: AccountProfile},
      meta: {title: 'accountMoneyClaimsDetails', auth: true},
    },
    {
      path: 'profile/:id/discounts',
      name: 'account-discounts',
      components: {default: AccountProfile},
      meta: {title: 'accountDiscounts', auth: true},
    },
    {
      path: 'profile/:id/municipalities',
      name: 'account-municipalities',
      components: {default: AccountProfile},
      meta: {title: 'accountMunicipalities', auth: true},
    },
    {
      path: 'profile/:id/payment-cards',
      name: 'account-payment-cards',
      components: {default: AccountProfile},
      meta: {title: 'accountPaymentCards', auth: true},
    },
    {
      path: 'profile/:id/payment-card-creations',
      name: 'account-payment-card-creations',
      components: {default: AccountProfile},
      meta: {title: 'accountPaymentCardCreations', auth: true},
    },
    {
      path: 'profile/:id/mobile-devices',
      name: 'account-mobile-devices',
      components: {default: AccountProfile},
      meta: {title: 'accountMobileDevices', auth: true},
    },
    {
      path: 'profile/:id/credit-debit-logs',
      name: 'credit-debit-logs',
      components: {default: AccountProfile},
      meta: {title: 'creditDebitLogs', auth: true},
    },
    {
      path: 'profile/:id/audit-logs/:resource_id',
      name: 'account-audit-log-details',
      components: {default: AccountProfile},
      meta: {title: 'accountAuditLog', auth: true},
    },
    {
      path: 'profile/:id/audit-logs',
      name: 'account-audit-logs',
      components: {default: AccountProfile},
      meta: {title: 'accountAuditLogs', auth: true},
    },
    {
      path: 'profile/:id/emails',
      name: 'account-emails',
      components: {default: AccountProfile},
      meta: {title: 'accountEmails', auth: true},
    },
    {
      path: 'profile/:id/season-tickets',
      name: 'account-season-tickets',
      components: {default: AccountProfile},
      meta: {title: 'accountSeasonTickets', auth: true},
    },
    {
      path: 'profile/:id/season-tickets/:season_ticket_id',
      name: 'account-season-ticket',
      components: {default: AccountProfile},
      meta: {title: 'accountSeasonTicket', auth: true},
    },
    {
      path: 'profile/:id/pos-operations',
      name: 'account-pos-operations',
      components: {default: AccountProfile},
      meta: {title: 'accountPosOperations', auth: true},
    },
    {
      path: 'profile/:id/inspection-events',
      name: 'account-inspection-events',
      components: {default: AccountProfile},
      meta: {title: 'accountInspectionEvents', auth: true},
    },
    {
      path: 'profile/:id',
      name: 'account-profile',
      components: {default: AccountProfile},
      meta: {title: 'accountProfile', auth: true},
    },
  ]
};

let operatorReportsPages = {
  path: '/operator-reports',
  component: DashboardLayout,
  name: 'operator-report',
  meta: {title: 'operator-report', auth: true},
  children: [
    {
      path: 'tickets',
      name: 'tickets',
      components: {
        default: OperatorTicketsReport,
      },
      meta: {title: 'operatorTicketsReport', auth: true, cacheable: true},
    },
    {
      path: 'journeys-stats',
      name: 'journeys-stats-report',
      components: {
        default: OperatorJourneyStatsReport,
      },
      meta: {title: 'operatorJourneyStatsReport', auth: true, cacheable: true},
    },
    {
      path: 'routes-stats',
      name: 'routes-stats-report',
      components: {
        default: OperatorRoutesStatsReport,
      },
      meta: {title: 'operatorRoutesStatsReport', auth: true, cacheable: true},
    },
    {
      path: 'journeys-count-report',
      name: 'journeys-count-report',
      components: {
        default: OperatorJourneysCountReport,
      },
      meta: {title: 'operatorJourneysCountReport', auth: true, cacheable: true},
    }
  ]
};

let reportsPages = {
  path: '/reports',
  component: DashboardLayout,
  name: 'report',
  meta: {title: 'report', auth: true},
  children: [
    {
      path: 'reporting-profiles',
      name: 'reporting-profiles',
      components: {default: ReportingProfiles},
      meta: {title: 'reportingProfiles', auth: true},
    },
    {
      path: 'reporting-profiles/:id',
      name: 'reporting-profile-view',
      components: {default: ReportingProfileView},
      meta: {title: 'reportingProfileView', auth: true},
    },
    {
      path: 'reporting-profiles/:id/tickets',
      name: 'reporting-profile-tickets-report',
      components: {default: ReportingProfileTicketsReport},
      meta: {title: 'reportingProfileTicketsReport', auth: true},
    },
    {
      path: 'credit-debit',
      name: 'credit-debit-report',
      components: {default: CreditDebitReport},
      meta: {title: 'creditDebitReport', auth: true},
    },
    {
      path: 'season-tickets-count',
      name: 'season-tickets-count',
      components: {default: SeasonTicketsCountReport},
      meta: {title: 'seasonTicketsCountReport', auth: true},
    },
    {
      path: 'inspection-locks',
      name: 'inspection-locks',
      components: {default: InspectionLocksReport},
      meta: {title: 'inspectionLocksReport', auth: true, cacheable: true},
    },
    {
      path: 'journeys-by-stop-municipalities',
      name: 'journeys-by-stop-municipalities',
      components: {default: JourneysByStopMunicipalitiesReport},
      meta: {title: 'journeysByStopMunicipalitiesReport', auth: true, cacheable: true},
    },
    {
      path: 'emv-taps-summary-report',
      name: 'emv-taps-summary-report',
      components: {default: EmvTapsSummaryReport},
      meta: {title: 'emvTapsSummaryReport', auth: true, cacheable: false},
    },
    {
      path: 'emv-success-payments-summary-report',
      name: 'emv-success-payments-summary-report',
      components: {default: EmvSuccessPaymentsReport},
      meta: {title: 'emvSuccessPaymentsSummaryReport', auth: true, cacheable: true},
    },
    {
      path: 'distributors',
      name: 'distributors_summary_report',
      components: {default: DistributorsSummaryReport},
      meta: {title: 'distributorsSummaryReport', auth: true},
    },
    {
      path: 'distributors/:id',
      name: 'distributor_report',
      components: {default: DistributorReport},
      meta: {title: 'distributorReport', auth: true},
    },
    {
      path: 'sold-season-tickets',
      name: 'sold_season_tickets_report',
      components: {default: SoldSeasonTicketsReport},
      meta: {title: 'soldSeasonTicketsReport', auth: true},
    },
    {
      path: 'canceled-season-tickets',
      name: 'canceled_season_tickets_report',
      components: {default: CanceledSeasonTicketsReport},
      meta: {title: 'canceledSeasonTicketsReport', auth: true},
    }
  ]
};

let systemPages = {
  path: '/system',
  name: 'System',
  meta: {title: 'systemAccounts', auth: true},
  redirect: '/system/system-accounts',
  component: DashboardLayout,
  children: [
    {
      path: 'system-accounts',
      name: 'system_accounts',
      components: {default: SystemAccounts},
      meta: {title: 'systemAccounts', auth: true},
    },
    {
      path: 'system-accounts/:id',
      name: 'system_account',
      components: {default: SystemAccount},
      meta: {title: 'systemAccount', auth: true},
    },
    {
      path: 'roles',
      name: 'roles',
      components: {default: Roles},
      meta: {title: 'roles', auth: true},
    },
    {
      path: 'inspector-teams',
      name: 'inspector_teams',
      components: {default: InspectorTeams},
      meta: {title: 'inspector_teams', auth: true},
    },
    {
      path: 'inspector-teams/:id',
      name: 'inspector_team',
      components: {default: InspectorTeam},
      meta: {title: 'inspector_team', auth: true},
    },
    {
      path: 'pt-locks',
      name: 'pt_locks',
      components: {default: PtLocks},
      meta: {title: 'pt_locks', auth: true}, // TODO: enable RBAC
    }
  ]
};

let userPages = {
  path: '/user',
  name: 'User',
  component: DashboardLayout,
  children: [
    {
      path: 'profile',
      name: 'profile',
      components: {default: Profile},
      meta: {title: 'profile', auth: true},
    }
  ]
};

Vue.router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: "/dashboard",
      component: DashboardLayout,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          components: {default: Starter},
          meta: {title: 'dashboard', auth: true},
        },
        {
          path: '/404',
          name: '404',
          component: NotFound,
          meta: {title: 'page404', auth: true},
        },
        {
          path: '/403',
          name: '403',
          component: Forbidden,
          meta: {title: 'page403', auth: true},
        },
      ]
    },

    authPages,
    userPages,
    accountPages,
    operatorReportsPages,
    reportsPages,
    dataPages,
    configPages,
    systemPages,
    {
      path: '*',
      name: 'notFoundLayout',
      component: AuthLayout,
      children: [
        {
          path: '/*',
          name: 'notFound',
          component: NotFound,
          meta: {title: 'page404'},
        }
      ]
    }
  ],
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
});

export default Vue.router;
